import { TImageType } from '../../../Helper/Image';
import React, { useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import Text from '../../Atoms/Text';
import Styles from './ItemsGrid.module.scss';
import Image from '../../Atoms/Image';
import { TProductData } from 'Pages/Home/Hooks/definitions';
import { joinClassnames } from 'helpers/classNames';

export type TDataSource = {
  title: string;
  price: string;
  image: string;
  category: string;
};

export type TItemsGridProps = {
  dataSource?: TProductData[];
  columnCount?: number;
  rowCount?: number;
  columnGap?: number;
  rowGap?: number;
  onPress?: (product: TProductData) => void;
};

const ItemsGrid: React.FC<TItemsGridProps> = ({
  dataSource,
  columnCount = 10,
  rowCount = 4,
  columnGap = 40,
  rowGap = 40,
  onPress = () => {},
  ...props
}) => {
  const gridTemplateColumns = useMemo(() => {
    return `repeat(${columnCount}, 1fr)`;
  }, [columnCount]);

  const gridTemplateRows = useMemo(() => {
    return `repeat(${rowCount}, 1fr)`;
  }, [rowCount]);

  const gridColumnGap = useMemo(() => {
    return columnGap;
  }, [columnGap]);

  const gridRowGap = useMemo(() => {
    return rowGap;
  }, [rowGap]);

  const renderItem = useMemo(() => {
    if (dataSource && dataSource.length > 0) {
      const data = dataSource;
      return data.map((item, index) => {
        const { title, image, category } = item;
        const imageSrc = image;
        return (
          <div
            key={`item-${index}`}
            className={joinClassnames(
              item.slug ? Styles['item'] : Styles['item-disabled'],
              index % columnCount === 0 && Styles['more-margin-left'],
              Number(String(index).slice(-1)) === (columnCount - 1) &&
                Styles['more-margin-right'],
            )}
            onClick={() => onPress(item)}
            {...props}
          >
            <Image
              src={imageSrc}
              style={{ width: '100%' }}
              alt={`${title}-image`}
              type={category as TImageType}
            />
            <Text
              className={joinClassnames(
                Styles['hover-text'],
                index % columnCount === 0 && Styles['left-align'],
                Number(String(index).slice(-1)) === (columnCount - 1) && Styles['right-align'],
              )}
              ellipsis
            >
              {title}
            </Text>
          </div>
        );
      });
    }
    return <div />;
  }, [dataSource]);

  return (
    <div
      key="item-grid"
      className={joinClassnames(
        Styles['wrapper'],
        columnCount === 5 && Styles['five-column'],
      )}
      style={{
        gridTemplateColumns,
        gridTemplateRows,
        gridColumnGap,
        gridRowGap,
      }}
    >
      {renderItem}
    </div>
  );
};

export default ItemsGrid;
